import React, { useEffect } from 'react';

import type { ModalProps } from '@fragment/ui/src/components/Modal/Modal';
import { Modal } from '@fragment/ui/src/components/Modal/Modal';

/**
 * Payments-specific modal wrapper that blurs the background content
 * when open. Passes all props through to the shared Modal component.
 */
export const PaymentsModal = <FontSizeProp,>(
  props: ModalProps<FontSizeProp>
) => {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- false positive: querySelector returns Element, need HTMLElement for .style
    const layout = document.querySelector(
      '[data-testid="dashboard-layout"]'
    ) as HTMLElement | null;
    if (layout) {
      layout.style.filter = 'blur(8px)';
      layout.style.transition = 'filter 0.1s ease-out';
    }
    return () => {
      if (layout) {
        layout.style.filter = '';
      }
    };
  }, []);

  return <Modal {...props} />;
};
